import React from 'react'
import Loader from 'react-loader-spinner'
import './button.scss'
const Button = ({
  children,
  title = '',
  loading = false,
  className = '',
  onClick = evt => {},
  type,
  disabled = false,
}) => {
  return (
    <button
      className={'f-button ' + className + ' ' + (loading ? 'loading' : '')}
      onClick={!disabled ? onClick : undefined}
      title={title}
      type={type ? type : 'button'}
    >
      {loading ? (
        <Loader type="Oval" color="#ffffff" height={22} width={30} />
      ) : (
        children
      )}
    </button>
  )
}

export default Button
